export default {
	name: 'AccountList',
    methods: {},
    computed: {},
};